import React from 'react';
import { useTranslation } from 'react-i18next';

import { useQuery, useRouter } from '../../hooks';
import { DIGITAL_SCORE_REPORT } from '../../graphql/queries/digitalScoreReport';
import { Loader } from '@ets-global/b2c-website-ui';
import NotFoundHandler from '../../components/NotFoundHandler';
import HeaderMeta from '../../components/HeaderMeta';

import './styles.scss';

const DigitalScoreReport = () => {
  const {
    currentRoute: {
      params: { digitalDocumentKey },
    },
  } = useRouter();

  const { t } = useTranslation();
  const {
    loading,
    data: { digitalScoreReportURL },
  } = useQuery(DIGITAL_SCORE_REPORT, { variables: { digitalDocumentKey } });

  return (
    <>
      <HeaderMeta
        meta={{
          title: t('digital-score-reports.meta.title'),
          description: t('digital-score-reports.meta.title'),
        }}
      />
      {!loading && !digitalScoreReportURL && <NotFoundHandler />}
      {!loading && digitalScoreReportURL && (
        <iframe
          src={digitalScoreReportURL}
          frameBorder="0"
          allowFullScreen={true}
          title={t('digital-score-reports.meta.title')}
        />
      )}
      {loading && <Loader />}
    </>
  );
};

export default DigitalScoreReport;
